import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Action() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className={`pb-6 bg-blue-100 flex flex-col items-center justify-center bg-slate-200 ${loaded ? 'slide-in' : ''}`}>
      <h1 className="py-8 text-black text-3xl font-bold px-4">Want to be Involved ?</h1>
      <img
        src="images/partners.png"
        alt="coming-soon"
        className="animate-pulse w-32 h-32"
        style={{ animationDuration: '5s' }} // Set animation duration to 5 seconds
      />

      <div className='flex flex-col flex-row items-center justify-center'>
        <h3 className='py-2 px-4 text-sm md:mt-0 text-balance text-center text-xl text-black font-roboto pb-4'>Donate, volunteer, or simply spread the word.</h3>
      </div>

      <div className='pb-4 flex items-center justify-center'>
        <Link to="/Donate">
          <button className='px-4 bg-red-600 rounded-full py-3 text-black font-bold transition-transform transform hover:scale-110'>LEARN WHAT YOU CAN DO</button>
        </Link>
      </div>
    </div>
  );
}

export default Action;
